module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ListHeader', {
    attrs: {
      "title": _vm.pageTitle,
      "back-route": "event.index"
    }
  }), _vm._v(" "), _c('el-card', {
    staticClass: "el-card__search_list box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Inserir presença")]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onInsert
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.onInsertClean
    }
  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "model": _vm.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Matrícula"
    }
  }, [_c('el-input', {
    ref: "formMatricula",
    attrs: {
      "name": "formMatricula",
      "placeholder": "Digite a matrícula ou leia com o leitor de códigos de barra"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.onInsert($event)
      }
    },
    model: {
      value: (_vm.form.ref_pessoa),
      callback: function($$v) {
        _vm.$set(_vm.form, "ref_pessoa", $$v)
      },
      expression: "form.ref_pessoa"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('ListMain', [_c('div', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-card', {
    staticClass: "el-card__search_list box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onFilter
    }
  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.onFilterClean
    }
  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Matrícula"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Filtrar por matrícula"
    },
    model: {
      value: (_vm.filters.ref_pessoa),
      callback: function($$v) {
        _vm.$set(_vm.filters, "ref_pessoa", $$v)
      },
      expression: "filters.ref_pessoa"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data de Entrada"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "format": "dd/MM/yyyy",
      "placeholder": "Filtrar por data"
    },
    model: {
      value: (_vm.filters.dates),
      callback: function($$v) {
        _vm.$set(_vm.filters, "dates", $$v)
      },
      expression: "filters.dates"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status Financeiro"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Filtrar Status",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.filters.status_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status_id", $$v)
      },
      expression: "filters.status_id"
    }
  }, _vm._l((_vm.dependencies.status), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData && _vm.event.id) ? _c('div', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Cód. Inscrição")]), _vm._v(" "), _c('th', [_vm._v("Participante")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Entrada")]), _vm._v(" "), _c('th', [_vm._v("Saída")]), _vm._v(" "), _c('th', [_vm._v("Financeiro")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.registration.person.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.registration.person.pessoa.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.event_modality_registration.event_modality.event.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.datetime_in)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.datetime_out)))]), _vm._v(" "), _c('td', [_c('div', [_c('registration-status-label', {
      attrs: {
        "status-id": item.registration.status_id,
        "status-name": item.registration.status.name
      }
    })], 1)]), _vm._v(" "), _c('td', [(!item.canceled_by) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "disabled": item.canceled_by,
        "title": "Cancelar Inscrição"
      },
      on: {
        "click": function($event) {
          _vm.cancelRegistrationActivity(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]) : _vm._e(), _vm._v(" "), (item.canceled_by) ? _c('div', [_c('el-tag', {
      attrs: {
        "type": _vm.labelType
      }
    }, [_vm._v("Cancelado")])], 1) : _vm._e()], 1)])
  })), _vm._v(" "), _c('tfoot')])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b02e66c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/Presence.vue
// module id = 753
// module chunks = 2